<template>
  <div id="jobFailModal" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div>
        <generic-job-error v-if="showGenericError"></generic-job-error>
        <max-exec-time-reached-error v-if="errorCode === 6020"></max-exec-time-reached-error>
        </div>
        <div class="modal-footer">
          <button class="btn close-btn" @click.prevent="close">
            <i class="fa fa-times mr-1"></i><strong>{{ 'Cancel' | trans }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../../mixins/store.mixin';
import { EventBus } from '../../../events/event.bus';
import {EVENT_JOB_FAIL} from "../../../events/job.events";
import user from "../../../mixins/user.mixin";
import currentJob from "../../../mixins/current_job.mixin";
import GenericJobError from "./Job/GenericJobError.vue";
import MaxExecTimeReachedError from "./Job/MaxExecTimeReachedError.vue";

export default {
  name: 'JobFailedModal',
  props: {},
  components: {MaxExecTimeReachedError, GenericJobError},
  mixins: [store, user, currentJob],
  data() {
    return {
      definedErrors: [
          6020
      ]
    }
  },
  mounted: function () {
    $('#jobFailModal').modal({ show: false });
  },
  created: function () {
    EventBus.$on(EVENT_JOB_FAIL, (error) => {
        $('#jobFailModal').modal('show');
    });
  },
  methods: {
    close() {
      $('#jobFailModal').modal('hide');
    },
  },
  computed: {
    showGenericError() {
      let errorCode = this.currentJob?.apiJob?.errors[0]?.code ?? 0;

      if (this.definedErrors.includes(errorCode)) {
        return false;
      }

      return true;
    },
    errorCode() {
      return this.currentJob?.apiJob?.errors[0]?.code ?? 0;
    }
  },
};
</script>
<style lang="scss">
#jobFailModal {
  img {
    width: 100%;
  }

  .modal-dialog {
    width: 599px;
    max-width: 95%;
    border-radius: 9px;
    overflow: hidden;
  }

  .close-btn {
    background: #d9d9d9;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
  }

  .premium-btn {
    background-color: #ffaa00;
    height: 38px;
    gap: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    padding: 0 10px 0 10px;
  }

  .modal-content-title {
    font-size: 28px;
    font-weight: 600;
  }

  .modal-content {
    h2 {
      margin-top: 0;
    }

    font-size: 17.5px;
    border: 1px solid #ccc;

    p {
      font-size: 17.5px;
    }
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    display: flex;
    padding: 10px 10px;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    background: #f8f9fa;

    .btn {
      margin: 0;
    }
  }
}
</style>
